// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__34U4a","content":"App_content__1LxwA","body":"App_body__1-ESN"};